import { setup } from './lib/allauth'

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8000'
const IGNORED_RESIZE_OBSERVER_ERRORS = new Set([
  'ResizeObserver loop completed with undelivered notifications.',
  'ResizeObserver loop limit exceeded'
])

function ignoreResizeObserverLoopErrors () {
  window.addEventListener('error', event => {
    if (IGNORED_RESIZE_OBSERVER_ERRORS.has(event.message)) {
      event.preventDefault()
      event.stopImmediatePropagation()
    }
  })
}

export function init () {
  ignoreResizeObserverLoopErrors()

  if (API_BASE !== 'http://localhost:8000') {
    // Production / custom backend
    setup('browser', `${API_BASE}/_allauth/browser/v1`, true)
  } else if (document.location.hostname === 'localhost') {
    // Local development setup
    if (document.location.port === '10000') {
      setup('browser', 'http://localhost:10000/_allauth/browser/v1', false)
    } else {
      setup('browser', 'http://localhost:8000/_allauth/browser/v1', true)
    }
  }
}
